"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreferenceKeybinding = void 0;
const react_1 = __importDefault(require("react"));
const KeybindingInput_1 = __importDefault(require("./KeybindingInput"));
const PreferenceKeybinding = (_a) => {
    var { setValue: setValueProp, value: valueProp } = _a, props = __rest(_a, ["setValue", "value"]);
    const setValue = (index) => (value) => {
        const result = [...valueProp];
        result[index] = value;
        setValueProp(result);
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(KeybindingInput_1.default, Object.assign({}, props, { placeholder: "First", setValue: setValue(0), value: valueProp[0] })),
        ' - ',
        react_1.default.createElement(KeybindingInput_1.default, Object.assign({}, props, { disabled: !valueProp[0] || valueProp[0].length === 0, placeholder: "Second", setValue: setValue(1), value: valueProp.length === 2 && valueProp[1] }))));
};
exports.PreferenceKeybinding = PreferenceKeybinding;
